import { membershipContentStore } from "../../../common/redux/membershipContent";

const mapAdyenRefusalCodeToContent = (refusalCode: string) => {
  const { reviewStep } = membershipContentStore.getState();

  switch (refusalCode) {
    case "6":
      return reviewStep.expiredCardErrorMessage;

    case "8":
      return reviewStep.invalidCardNumberErrorMessage;

    case "24":
      return reviewStep.cvcDeclinedErrorMessage;

    default:
      return reviewStep.paymentError;
  }
};

export default mapAdyenRefusalCodeToContent;
